import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './index.module.scss';
import { Table, message, Typography, Popover, Alert } from 'antd';
import { XOKButton } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import model from '@/reducers/system/dictionaries/model';
import CreateAndEdit from './modal/CreateAndEdit';
import http from '@/assets/api/http';
import { InfoCircleTwoTone } from '@ant-design/icons';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const dictionarieList = ({
    setBreadcrumbPaths,
    match,
    getDictionarieList,
    dictionarieList = []
}) => {

    const [renderMode, setRenderMode] = useState(false);
    const [modeParams, setModeParams] = useState({});
    const [updateList, setUpdateList] = useState(false);
    const [hasTip, setHasTip] = useState(false);
    const [clearParams, setClearParams] = useState(false);


    useEffect(() => {
        getDictionarieList();
        setBreadcrumbPaths(match); // 自动识别面包屑
    }, []);

    useEffect(() => {
        if (updateList) {
            getDictionarieList();
            setUpdateList(false);
            setClearParams(true);
        }
    }, [updateList]);

    useEffect(() => {
        if (clearParams) {
            setModeParams({});
            setClearParams(false);
        }
    }, [clearParams]);

    const onRequest = (id) => {
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyDisplayPositionService.delStrategyDisplayPosition', { id }, 'POST')
            .then(() => {
                message.success('删除攻略分类字典操作成功');
                setUpdateList(true);
            }).catch((e = {}) => {
                message.error(e.message);
            });
    };

    const onOperateCell = (text, item) => {
        return <div className={styles.action}>
            <div
                className={styles.item}
                onClick={() => {
                    setRenderMode(true);
                    setModeParams(item);
                }}
            >编辑</div>
            <div
                className={styles.item}
                onClick={() => onRequest(text)}
            >删除</div>
        </div>;
    };

    const titleNode = () => {

        return <div>
            <Typography.Text>攻略分类名称</Typography.Text>
            <Popover
                style={{ padding: '0px' }}
                title={null}
                content={<Alert
                    message='帮助提示'
                    description='攻略分类名称定义了显示位置；在固定的位置显示关联的攻略分类和攻略分类对应的攻略列表；'
                    type='info'
                    showIcon
                />}
                trigger="click"
                visible={hasTip}
                onVisibleChange={() => setHasTip(!hasTip)}
            >
                <InfoCircleTwoTone style={{ fontSize: '14px', marginLeft: '10px' }} />
            </Popover>
        </div>;
    };

    const columns = [
        {
            title: '编码',
            dataIndex: 'displayPositionCode',
            key: 'displayPositionCode',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: titleNode(),
            dataIndex: 'displayPositionName',
            key: 'displayPositionName',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '更新时间',
            dataIndex: 'gmtModified',
            key: 'gmtModified',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: onOperateCell
        }
    ];

    return <div className={styles.flexBoxContainer}>
        <XOKButton style={{ width: '120px' }} label='新建分类字典' onClick={() => setRenderMode(true)} />
        <div className={styles.tableContainer}>
            <Table
                rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                rowKey={record => record.id}
                columns={columns}
                dataSource={dictionarieList}
                pagination={false}
                scroll={{ y: true }}
            />
        </div>
        {renderMode &&
            <CreateAndEdit
                modeParams={modeParams}
                setRenderMode={setRenderMode}
                setUpdateList={setUpdateList}
                setClearParams={setClearParams}
            />}
    </div>;
};

dictionarieList.propTypes = {
    getDictionarieList: PropTypes.func,
    dictionarieList: PropTypes.array,
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

export default connect(state => ({
    dictionarieList: state.dictionaries.dictionarieList,
}), { setBreadcrumbPaths, ...model.actions })(dictionarieList);
